import { createAsyncThunk } from '@reduxjs/toolkit';

import AuthApi, { SignInDto } from 'api/AuthApi';

export const loginThunk = (authApi: AuthApi) =>
  createAsyncThunk('account/Login', async (signIn: SignInDto, {}) => {
    const { email, password, refreshToken } = signIn;

    const sessionInfo = await authApi.login(email, password, refreshToken);

    localStorage.setItem('token', sessionInfo!.accessToken);
    localStorage.setItem('refreshToken', sessionInfo!.refreshToken);

    return sessionInfo;
  });
